import rule from './rule'
import detail from './detail'
import { MessagePlugin } from 'tdesign-vue-next'
import {
  API,
  Request,
  setCookie,
  getCookie
} from '@/lib/index.js'
export default {
  modules: {
    rule,
    detail
  },
  state: {
    navList: [],
    hotWords: [],
    leftNavList: [],
    noticeList: [],
    categoryId: undefined,
    childCategoryId: undefined,
    count: 1,
    localCount: 200,
    userInfo: {},
    isLogin: false,
    violationAnnouncementInfo: {}
  },
  mutations: {
    updateNavs (state, payload) {
      state.navList = payload
    },
    updateHotWords (state, payload) {
      state.hotWords = payload
    },
    updateLeftNavs (state, payload) {
      state.leftNavList = payload
    },
    updateNoticeList (state, payload) {
      state.noticeList = payload
    },
    updateCategoryId (state, payload) {
      state.categoryId = payload.categoryId
      state.childCategoryId = payload.childCategoryId
    },
    updateUserInfo (state, payload) {
      state.userInfo = payload
    },
    updateLoginState(state, payload)  {
      state.isLogin = payload
    },
    incrementTest (state, payload) {
      // 变更状态
      state.count += (payload | 1)
    },
    updateViolationAnnouncementInfo(state, payload)  {
      state.violationAnnouncementInfo = payload
    }
  },
  getters: {
    getCount (state, getters) {
      return state.count + getters.getersTest
    },
    getersTest (state) {
      return state.localCount
    }
  },
  actions: {
    getRootToSpecificLayer (context, layer) {
      return new Promise((resolve) => {
        Request(API.getRootToSpecificLayer, {
          layer
        }).then((resp) => {
          const result = resp || {}
          const navList = result.children || []
          resolve(navList)

        })
      })
    },
    getNavs ({dispatch, commit}) {
      dispatch('getRootToSpecificLayer', 1).then((resp) => {
        commit('updateNavs', resp)
      })
    },
    listHotKeywords ({commit}, payload) {
      Request(API.listHotKeywords, {
        n: payload
      }).then((resp) => {
        let result = resp || []
        commit('updateHotWords', result)
      })
    },
    getHotKeyWords ({dispatch}, len = 5) {
      dispatch('listHotKeywords', len)
    },
    searchCompletionSuggester (context, {phrase}) {
      return new Promise((resolve) => {
        if (!phrase || !phrase.trim()) {
          return resolve([])
        }
        let param = phrase.trim()
        let reg = new RegExp(param, 'g')
        Request(API.searchCompletionSuggester, {
          keyPhrase: {
            phrase: param
          }
        }).then((resp) => {
          let result = resp || []
          result = result.map((item) => {
            item.desc = item.title.replace(reg, function ($$) {
              return `<em>${$$}</em>`
            })
            return item
          })
          resolve(result)
        }).catch(() => {
          resolve([])
        })
      })
    },
    getLeftNavList ({dispatch, commit}) {
      dispatch('getRootToSpecificLayer', 2).then((resp) => {
        commit('updateLeftNavs', resp)
      })
    },
    getNoticeOverview ({commit}, payload) {
      const {
        pageNo,
        pageSize
      } = payload
      return new Promise((resolve, reject) => {
        Request(API.getNoticeOverview, {
          categoryId: null,
          page: {
            pageNo,
            pageSize
          }
        }).then((resp) => {
          const result = resp || []
          resolve(true)
          commit('updateNoticeList', result)
        }).catch(() => {
          reject()
        })
      })
    },
    getUserInfo ({commit}) {
      return new Promise((resolve, reject) => {
        Request(API.getUserInfo, {}).then((resp) => {
          const result = resp || {}
          resolve(result)
          if (result) {
            if (result.castgc) {
              setCookie('rule_token', resp.castgc, 8 * 3600 * 1000, 'vip.com')
              // 1 是通过castgc登录 2是passport登录
              setCookie('rule_login_type', '1', 8 * 1000, 'vip.com')
              window.sessionStorage.setItem('rule_login_type', '1')
            } else {
              setCookie('rule_token', '', -1, 'vip.com')
            }
          } else {
            setCookie('rule_token', '', -1, 'vip.com')
            setCookie('rule_login_type', '', -1, 'vip.com')
          }
          commit('updateUserInfo', result)
        }).catch(() => {
          setCookie('rule_token', '', -1, 'vip.com')
          setCookie('rule_login_type', '', -1, 'vip.com')
          reject({})
        })
      })
    },
    signIn ({commit}) {
      return new Promise((resolve) => {
        Request(API.signIn, {}).then((resp) => {
          const result = resp || false
          resolve({result})
          commit('updateLoginState', result)
        }).catch(() => {
          resolve({})
        })
      })
    },
    signOut ({commit}) {
      return new Promise((resolve) => {
        Request(API.signOut, {
          token: getCookie('PASSPORT_ACCESS_TOKEN') || 'PASSPORT_ACCESS_TOKEN'
        }).then((resp) => {
          const result = resp || false
          resolve(result)
          if (result) {
            commit('updateUserInfo', {})
          } else {
            MessagePlugin.warning({ content: '用户退出失败' })
          }
        }).catch(() => {
          resolve({})
        })
      })
    },
    increment (context, payload) {
      context.commit('incrementTest', payload)
    },
    queryViolationAnnouncement ({commit}, payload) {
      return new Promise((resolve) => {
        Request(API.queryViolationAnnouncement, {
          request: {
            page: payload.pageNo,
            size: payload.pageSize
          }
        }).then((resp) => {
          const result = resp || {}
          result.dataInfo = result.dataInfo || []
          resolve(result)
          commit('updateViolationAnnouncementInfo', result)
        }).catch(() => {
          resolve({})
        })
      })
    }
  }
}
